import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../baseQuery";

export interface SmS {
  _id?: string;
  sender: string;
  receivers: string[];
  msg: string;
  status: string;
  receiver?: string;
  include_names?: string;
  specefic_students?: string[];
  sms_par_destinataire?: string;
  total_sms?: string;
  eleve?: string;
}

export interface SoldeResponse {
  error: string;
  nbrsms: string;
  senderListe: string;
  solde: string;
}

export const smSSlice = createApi({
  reducerPath: "SmS",
  baseQuery: baseQueryWithAuth("msgSms"),
  tagTypes: ["SmS"],
  endpoints(builder) {
    return {
      fetchSmS: builder.query<SmS[], number | void>({
        query() {
          return `/getSms`;
        },
        providesTags: ["SmS"],
      }),
      sendSmS: builder.mutation<void, void>({
        query() {
          return {
            url: "/send-pending-smses",
            method: "POST",
          };
        },
        invalidatesTags: ["SmS"],
      }),
      fetchsolde: builder.mutation<SoldeResponse, {api_key: string}>({
        query(payload) {
          return {
            url: "/soldeSms",
            method: "POST",
            body: payload,
          };
        },
        invalidatesTags: ["SmS"],
      }),
      fetchBalance: builder.query<any, void>({
        query() {
          return `/balance`;
        },
      }),
      addSmS: builder.mutation<void, SmS>({
        query(payload) {
          return {
            url: "/createSms",
            method: "POST",
            body: payload,
          };
        },
        invalidatesTags: ["SmS"],
      }),
      updateSmS: builder.mutation<void, SmS>({
        query: ({ _id, ...rest }) => ({
          url: `/updateSms/${_id}`,
          method: "PATCH",
          body: rest,
        }),
        invalidatesTags: ["SmS"],
      }),
      deleteSmS: builder.mutation<void, string[]>({
        query: (ids) => ({
          url: `/deleteSms`,
          method: "DELETE",
          body: { ids },
        }),
        invalidatesTags: ["SmS"],
      }),
      deleteSmsEnAttente: builder.mutation<void, void>({
        query() {
          return {
            url: "/delete-pending-smses",
            method: "DELETE",
          };
        },
        invalidatesTags: ["SmS"],
      }),
    };
  },
});

export const {
  useAddSmSMutation,
  useDeleteSmSMutation,
  useFetchSmSQuery,
  useUpdateSmSMutation,
  useSendSmSMutation,
  useDeleteSmsEnAttenteMutation,
  useFetchsoldeMutation,
  useFetchBalanceQuery,
} = smSSlice;
